module.exports = __webpack_public_path__ + "img/whiteCard.26f76848.svg";